import { render, staticRenderFns } from "./RateBarChart.vue?vue&type=template&id=dda22c5c&scoped=true"
import script from "./RateBarChart.vue?vue&type=script&lang=js"
export * from "./RateBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda22c5c",
  null
  
)

export default component.exports